/** Personal Microsoft account (MSA) email domains. */
const MICROSOFT_CONSUMER_DOMAINS = new Set(['outlook.com', 'live.com', 'hotmail.com', 'msn.com']);

const OUTLOOK_CONSUMER_HOST = 'outlook.live.com';
const OUTLOOK_WORK_HOST = 'outlook.office.com';

const getEmailDomain = (email?: string | null): string | null => {
  if (!email) {
    return null;
  }
  const atIndex = email.lastIndexOf('@');
  if (atIndex < 0 || atIndex === email.length - 1) {
    return null;
  }
  return email
    .slice(atIndex + 1)
    .trim()
    .toLowerCase();
};

/** True when the address is a personal Microsoft account domain. */
export const isMicrosoftConsumerEmail = (email?: string | null): boolean => {
  const domain = getEmailDomain(email);
  return domain != null && MICROSOFT_CONSUMER_DOMAINS.has(domain);
};

/**
 * Outlook on the web host for compose/edit deeplinks.
 * Consumer MSA uses outlook.live.com; work/school (and unknown) use outlook.office.com.
 */
export const getOutlookWebHost = (email?: string | null): string =>
  isMicrosoftConsumerEmail(email) ? OUTLOOK_CONSUMER_HOST : OUTLOOK_WORK_HOST;
